/* eslint-disable import/prefer-default-export */

export function eventGuestStoragePath(eventId, document) {
  return `events/${eventId}/${document}`;
}
